import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full bg-white border border-[#E5E7EB] rounded-xl pt-5 px-5 pb-0 shadow-sm text-left" }
const _hoisted_2 = { class: "text-[20px] font-bold text-textPrimary mb-2 tracking-tight" }
const _hoisted_3 = {
  key: 0,
  class: "relative pb-5"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "absolute left-[4px] top-[10px] bottom-0 w-[2px] bg-[#CBD5E1] z-0" }, null, -1)
const _hoisted_5 = { class: "relative flex flex-col items-center shrink-0" }
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "text-[15px] text-[#323232] leading-snug" }
const _hoisted_8 = { class: "font-bold mr-1.5" }
const _hoisted_9 = { class: "font-normal" }
const _hoisted_10 = { class: "text-[13px] text-gray-500 mt-0.5 font-normal tracking-wide" }
const _hoisted_11 = {
  key: 0,
  class: "mt-0.5 flex flex-wrap gap-x-3"
}
const _hoisted_12 = ["data-testid", "onClick"]
const _hoisted_13 = {
  key: 1,
  class: "flex flex-col items-center justify-center py-6 pb-8 text-center"
}
const _hoisted_14 = { class: "text-sm text-gray-400 font-medium" }

import { PropType } from 'vue'
import { mdiClockOutline } from '@mdi/js'
import { useErrorToast } from '@/composables/useErrorToast'
import { openDsAttendanceContainerInNewTab } from '@/utils/openDsAttendanceContainer'

export interface HistoryEventLink {
  label: string
  containerId: number
}

export interface HistoryEvent {
  date: string
  description: string
  time: string
  isPrimary?: boolean
  /** Spec 2026-09-24 §7 — registro contraparte de uma sobrescrita de perna. */
  links?: HistoryEventLink[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendanceHistoryCard',
  props: {
  title: {
    type: String,
    default: 'Histórico'
  },
  events: {
    type: Array as PropType<HistoryEvent[]>,
    required: true,
    default: () => []
  },
  emptyText: {
    type: String,
    default: 'Nenhum registro encontrado.'
  }
},
  setup(__props) {



const { notifyError } = useErrorToast()

async function openLink(containerId: number) {
  try {
    await openDsAttendanceContainerInNewTab(containerId)
  } catch (error) {
    notifyError(error, 'Não foi possível abrir o registro.')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1),
    (__props.events.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.events, (event, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "flex gap-4 relative z-10 mb-2 last:mb-0"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(["w-2.5 h-2.5 rounded-full mt-1.5 z-10", event.isPrimary ? 'bg-[#34818F]' : 'bg-[#323232]'])
                }, null, 2)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(event.date), 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(event.description), 1)
                ]),
                _createElementVNode("p", _hoisted_10, _toDisplayString(event.time), 1),
                (event.links?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(event.links, (link) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: link.containerId,
                          type: "button",
                          class: "text-[13px] font-semibold text-primary30 underline",
                          "data-testid": `history-event-link-${link.containerId}-button`,
                          onClick: ($event: any) => (openLink(link.containerId))
                        }, _toDisplayString(link.label), 9, _hoisted_12))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_v_icon, {
            size: 40,
            color: "#CBD5E1",
            class: "mb-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(mdiClockOutline)), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", _hoisted_14, _toDisplayString(__props.emptyText), 1)
        ]))
  ]))
}
}

})